import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0f2424] pt-20 px-4 sm:px-0" data-id="element-83">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1a3a3a] via-[#0f2424] to-[#0f2424] opacity-50" data-id="element-84"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-85">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-86">
          {/* Content - Moved higher with negative margin */}
          <div className="space-y-6 sm:space-y-8 max-w-2xl text-center lg:text-left mx-auto lg:mx-0 -mt-8 sm:-mt-12 lg:-mt-20" data-id="element-87">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-88">
              Building the Future of{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4fd1c5] to-teal-600" data-id="element-89">
                Neighborhood Laundry
              </span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-400 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-90">
              We acquire independently owned laundromats in Florida, implement
              proven systems and processes, and provide owners with the freedom
              and liquidity they deserve.
            </p>

            <div className="pt-2 sm:pt-4" data-id="element-91">
              <Link to="/contact" data-id="element-92">
                <Button size="lg" className="group w-full sm:w-auto" data-id="element-93">
                  Partner With Us Today
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-94" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Animated Graphic - Positioned to avoid header cutoff */}
          <div className="flex justify-center items-center relative h-[300px] sm:h-[400px] lg:h-[500px] order-first lg:order-last pt-8 lg:pt-0" data-id="element-95">
            {/* Outer Ring */}
            <div className="absolute w-[250px] h-[250px] sm:w-[300px] sm:h-[300px] lg:w-[350px] lg:h-[350px] rounded-full border border-[#4fd1c5]/10 animate-[spin_10s_linear_infinite]" data-id="element-96"></div>

            {/* Middle Ring */}
            <div className="absolute w-[170px] h-[170px] sm:w-[200px] sm:h-[200px] lg:w-[230px] lg:h-[230px] rounded-full border border-[#4fd1c5]/20 border-t-[#4fd1c5] animate-[spin_3s_linear_infinite]" data-id="element-97"></div>

            {/* Inner Ring */}
            <div className="absolute w-[90px] h-[90px] sm:w-[100px] sm:h-[100px] lg:w-[120px] lg:h-[120px] rounded-full border-2 border-[#4fd1c5]/30 border-b-[#4fd1c5] animate-[spin_5s_linear_infinite_reverse]" data-id="element-98"></div>

            {/* Center Glow */}
            <div className="absolute w-3 h-3 sm:w-4 sm:h-4 bg-[#4fd1c5] rounded-full shadow-[0_0_30px_15px_rgba(79,209,197,0.2)] sm:shadow-[0_0_40px_20px_rgba(79,209,197,0.2)] animate-pulse" data-id="element-99"></div>
          </div>
        </div>
      </div>
    </section>;
}